fragment CoreDocumentFields on Document {
  id
  filename
  path
  type
  url
  temporary_url
  size
  created_at
}
